import React, { Component } from 'react';

import LoginForm from '../../components/LoginForm';

export default class LoginPage extends Component {
  render() {
    return <LoginForm />;
  }
}
